//#region IMPORT
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import dayjs from 'dayjs';
//#endregion

/**
 * 일반/특수 건강진단 - 특수건강진단 (HEA_BASIC_02) 전용 로직
 * other 케이스에서 사용
 */

// 특수건강진단 인쇄 함수 (PrintLogic1) - printItem printType: '1'
export const PrintLogic1 = async (
  documentData,
  dispatch,
  setLoading,
  rowData1,
  searchRef,
  userInfo
) => {
  setLoading(true);

  try {
    // 데이터 확인
    const currentRowData = (rowData1 || []).filter((row) => !row.deleteYn);

    if (currentRowData.length === 0) {
      dispatch(
        showSnackbar({
          message: '인쇄할 데이터가 없습니다.',
          type: 'warning',
        })
      );
      return null;
    }

    // 사업장명 가져오기
    const custNm =
      searchRef?.current?.custList?.find(
        (item) => item.value === searchRef?.current?.custCd
      )?.custNm || '';

    // HeaderData 설정
    const headerData = {
      custNm: custNm, // 사업장명
      createDate: dayjs().format('YYYY-MM-DD'), // 작성일자
      userNm: userInfo.userNm || '', // 사용자명
    };
    // TableData 매핑 (레포트 양식에 맞게) - 최신 rowData1 사용
    const tableData = currentRowData.map((row, index) => {
      // 배치전/특수 변환
      const checkType =
        row.checkType === '0' ||
          row.checkType === 0 ||
          row.checkType === '배치전'
          ? '배치전'
          : row.checkType === '1' ||
            row.checkType === 1 ||
            row.checkType === '특수'
            ? '특수'
            : '';

      // workEnvironmentType 문자열을 파싱하여 텍스트로 변환
      // 0:소음, 1:분진, 2:야간작업, 3:화학물질
      const workEnvironmentTypeValue = row.workEnvironmentType || '';
      const workTypes = [];
      if (workEnvironmentTypeValue.includes('0')) {
        workTypes.push('소음');
      }
      if (workEnvironmentTypeValue.includes('1')) {
        workTypes.push('분진');
      }
      if (workEnvironmentTypeValue.includes('2')) {
        workTypes.push('야간');
      }
      if (workEnvironmentTypeValue.includes('3')) {
        workTypes.push('화학물질');
      }
      const workEnvironmentType = workTypes.join('/') || '';

      // 건강관리 구분 코드를 문자열로 변환
      const hscGubunCode = row.hscGubun || '';
      const hscGubunValueMap = {
        A: 'A(이상없음)',
        D1: 'D1 (직업병 유소견자)',
        D2: 'D2(일반질병 유소견자)',
        C1: 'C1(직업병 요관찰자)',
        C2: 'C2(일반질병 요관찰자)',
        R: 'R(재검)',
      };
      const hscGubunText = hscGubunValueMap[hscGubunCode] || hscGubunCode;

      // 검진일 포맷팅
      const checkupDate = row.hcDate
        ? dayjs(row.hcDate).format('YYYY-MM-DD')
        : '';

      // 유효일자 포맷팅
      const effeDate = row.hcEffeDate
        ? dayjs(row.hcEffeDate).format('YYYY-MM-DD')
        : '';

      return {
        no: index + 1,
        checkType: checkType, // 배치전/특수
        depNm1: row.depNm1 || '', // 본부
        depNm2: row.depNm2 || '', // 부서
        depNm3: row.depNm3 || '', // 팀
        depNm4: row.depNm4 || '', // 파트
        position: row.position || '', // 직책
        name: row.name || '', // 성명
        hscGubun: hscGubunText, // 건강관리 구분
        workEnvironmentType: workEnvironmentType, // 소음/분진/야간작업/화학물질 취급작업
        hcSubstance: row.hcSubstance || '', // 취급물질
        hcPost: row.hcPost || '', // 배치 후
        hcCycle: row.hcCycle || '', // 검진주기 (월)
        hcDate: checkupDate, // 검진일
        hcEffeDate: effeDate, // 유효일자
        hcAlarmYn: row.hcAlarmYn || '', // 알람여부(Y/N)
        hcCheckupCenter: row.hcCheckupCenter || '', // 검진기관
        hcRemark: row.hcRemark || '', // 비고
      };
    });

    const printData = {
      FileName: 'HEA_BASIC_02',
      HeaderData: JSON.stringify(headerData),
      TableData: JSON.stringify(tableData),
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    return response.data; // Blob 반환
  } catch (e) {
    console.error(e);
    dispatch(showSnackbar({ message: e.message, type: 'error' }));
    return null;
  } finally {
    setLoading(false);
  }
};

// 건강진단 실시 지침서 인쇄 함수 (PrintLogic2) - printItem printType: '2'
export const PrintLogic2 = async (
  _value1,
  dispatch,
  setLoading,
  searchRef
) => {
  setLoading(true);

  try {
    const printData = {
      FileName: 'HEA_BASIC',
      HeaderData: JSON.stringify({}),
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    return response.data; // Blob 반환
  } catch (e) {
    console.error(e);
    dispatch(showSnackbar({ message: e.message, type: 'error' }));
    return null;
  } finally {
    setLoading(false);
  }
};

